// eslint-disable-next-line simple-import-sort/imports
import { StrictMode } from 'react';
import * as ReactDOM from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
// Mantine base CSS must be loaded before portal-ui so that portal-ui's CSS
// modules (injected later in Vite dev) win the cascade over Mantine defaults.
import './styles.scss';
import { MantineProvider } from '@mantine/core';
import {
  activateAgGridEnterprise,
  portalMantineTheme,
} from '@asset-metrix/portal-ui';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

import './sentryConfig';

import { router } from './app/routes';
import { applyThemeVariables, useColorScheme } from './app/usePortalTheme';
import { queryClient } from './utils/queryClient';
import { AG_GRID_LICENSE_KEY, RELEASE_VERSION } from './config';
import { RowGroupingModule } from 'ag-grid-enterprise';

console.log(
  '%cPortal-Next version: %s',
  'font-size: 16px; font-family: "Arial Black", sans-serif; border: 2px solid #B32728; padding: 10px',
  RELEASE_VERSION
);

activateAgGridEnterprise(AG_GRID_LICENSE_KEY, [RowGroupingModule]);

const root = ReactDOM.createRoot(
  document.querySelector('#root') as HTMLElement
);

// Set default theme variables outside of React context, because they are overwritten once the tenant theme is applied
applyThemeVariables();

function Application() {
  const [colorScheme] = useColorScheme();

  return (
    <StrictMode>
      {/* MantineProvider creates an emotion cache */}
      <MantineProvider
        theme={portalMantineTheme}
        forceColorScheme={colorScheme}
      >
        <QueryClientProvider client={queryClient}>
          <RouterProvider router={router} />
          <ReactQueryDevtools buttonPosition="top-left" />
        </QueryClientProvider>
      </MantineProvider>
    </StrictMode>
  );
}

root.render(<Application />);
